import React, { useEffect, useState } from 'react';
import './SmallCard.css';

import CartManager from '../Cart/CartManager';



function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const SmallCard = (props) => {

    const [inCart, setInCart] = useState(props.inCart)

    function addToCart(props) {
        CartManager.add({product_id: props.pid, quantity: 1, unit_price: props.price_ex, total_price: props.price_ex, img: props.img, title: props.title, cart_id: CartManager.getCartId()});
        setInCart(true);
    }

    function removeFromCart(pid) {
        CartManager.removeFromCart(pid, 1);
        setInCart(false);
    }

    useEffect(() => {
        setInCart(props.inCart);
        if(typeof inCart === undefined) {
            CartManager.isInCart(props.pid).then((res) => {
                setInCart(res);
            });
        }

        window.addEventListener('storage', storageEventHandler, false);
        async function storageEventHandler(e) {
            if(typeof inCart === undefined) {
                CartManager.isInCart(props.pid).then((res) => {
                    setInCart(res);
                });
            }
            /*
            CartManager.isInCart(props.pid).then((res) => {
                setIsInCart(res);
            });*/
        }
    },[props.inCart])

    const product_link = `/shipping-container/${props.location}/${props.pid}`

    return (
        <div className={`SmallCard bg-light`}>
            <div className="CardImage" style={{backgroundImage: `url(${props.img})`}}>
                <a href={product_link}>
                    <img src={props.img} alt={props.title} fetchpriority={props.priority ? props.priority : "auto"} />
                </a>
            </div>
            <div className="CardPrice">
                <span className='PriceText'>${props.price ? numberWithCommas(props.price.toFixed(2)) : "TBA"} inc.</span>
            </div>
            <div className="CardText">
                <a href={product_link} className='flex-7'>
                    <h3 className='no-block-end no-block-start'>{props.title}</h3>
                </a>
                {
                    !props.extraSmall &&
                    <div>
                        <p>{props.children}</p>
                    </div>
                }
            </div>
            {
                !props.extraSmall &&
                <div className="CardButtons d-flex">
                    <a href={product_link} className='flex-7'>
                        <div className="Button text-center flex-7 d-flex align-center justify-center shadow">View Product</div>
                    </a>
                    <div className="flex-1"></div>
                    {
                        inCart ?
                        <div className="Button text-center flex-5 d-flex align-center justify-center grayscale shadow" onClick={()=>removeFromCart(props.pid)}>Remove</div>
                        :
                        <div className="Button text-center flex-5 d-flex align-center justify-center shadow" onClick={()=>addToCart(props)}>Add To Cart</div>
                    }
                </div>
            }
        </div>
    );
};

export default SmallCard;